import localforage from "localforage";

export const appStorage = localforage.createInstance({
  version: 1,
  description: "Provider Portal Storage",
});
